module.exports = __webpack_public_path__ + "fonts/60fa3c0614b8fb2f394fa29944c21540.woff";